// extracted by mini-css-extract-plugin
export default {"screen":"zRjCKt mz-default-dark-font"};